import React, {useMemo} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";

const SupplierTable = ({data, selectId, select}) => {

    const columns = useMemo(
        () => [
            {
                header: 'Наименование',
                accessorKey: 'name',
                minSize: 30,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        ],
        [data],
    );

    return <MaterialReactTable
        renderTopToolbar={({table}) => {
            return <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "7px",
                backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
            }}>
                <MRT_ToolbarAlertBanner table={table}/>
                <Box sx={{display: "flex"}}>
                    <MRT_ToggleFiltersButton table={table}/>
                    <MRT_GlobalFilterTextField table={table}/>
                </Box>
            </Box>
        }}
        selectAllMode={"all"}
        muiTableBodyCellProps={{
            sx: {
                p: '0px 0px 0px 10px',
                m: '0px 0px 0px 0px',
                border: "none",
                "&:after": {
                    display: "none",
                },
                "& td:after": {
                    "&:hover": {
                        backgroundColor: "red"
                    }
                },
                "&:not(:last-of-type)": {
                    borderRight: '1px solid #EAEBEA',

                },
            },
        }}
        muiTableHeadCellProps={{
            sx: {
                border: '1px solid #EAEBEA',
                backgroundColor: "#F5F6FA",
                padding: "10px",
                paddingBottom: " 0.2rem",
                paddingTop: "0.2rem",
                "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                    "minWidth": "100%"
                }
            },
        }}

        muiTableBodyRowProps={({row}) => {
            return ({
                onClick: () => select && select(row.original),
                sx: () => ({
                    height: '36px',
                    cursor: select && "pointer",
                    "&:hover& td:after": {
                        display: "none",
                    },
                    '&:nth-of-type(even)': {
                        backgroundColor: row.original.id === selectId ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            backgroundColor: row.original.id === selectId ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                        },
                    },
                    backgroundColor: row.original.id === selectId ? (theme) => theme.palette.primary.light : "white",
                    "&:hover": {
                        backgroundColor: row.original.id === selectId ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                    },
                    "&.MuiTableRow-root.Mui-selected": {
                        backgroundColor: (theme) => theme.palette.primary.light70,
                        "&:hover": {
                            backgroundColor: (theme) => theme.palette.primary.light50,
                        },
                    },
                })
            })
        }}

        muiSearchTextFieldProps={{
            placeholder: `Поиск`,
            sx: {
                paddingTop: "5px",
                paddingBottom: "0px",
                "& .MuiCollapse-root": {
                    borderRadius: '12px',
                    height: 40, width: 290,
                    "& .MuiSvgIcon-root": {
                        color: "#737478"
                    },
                    '& .MuiOutlinedInput-input': {
                        padding: 0
                    }
                }
            },
            variant: 'outlined',
        }}

        columns={columns}
        data={data}
        initialState={{
            columnVisibility: {
                id: false,
            },
            density: "compact",
            pagination: {pageIndex: 0, pageSize: 10},
        }}
        state={{showGlobalFilter: true}}
        enableToolbarInternalActions={false}
        localization={MRT_Localization_RU}
        getRowId={(originalRow) => originalRow.id}
    />;
};

export default SupplierTable;